__turbopack_context__.v({
  "bannerCard": "ScholarshipBenefits-module-scss-module__keBpzW__bannerCard",
  "bgImage": "ScholarshipBenefits-module-scss-module__keBpzW__bgImage",
  "content": "ScholarshipBenefits-module-scss-module__keBpzW__content",
  "ctaButton": "ScholarshipBenefits-module-scss-module__keBpzW__ctaButton",
  "description": "ScholarshipBenefits-module-scss-module__keBpzW__description",
  "heading": "ScholarshipBenefits-module-scss-module__keBpzW__heading",
  "section": "ScholarshipBenefits-module-scss-module__keBpzW__section",
  "white": "ScholarshipBenefits-module-scss-module__keBpzW__white",
  "yellow": "ScholarshipBenefits-module-scss-module__keBpzW__yellow",
});
